import PropTypes from 'prop-types';
import { useGetImages } from '../../../hooks';
import { getImageData } from '../../../utils';

const useThumbnailImage = ({
  imageId,
  imageIndex,
  enableLightbox,
  toggleModal,
  handleSelectedImage,
  priority,
  selectedImageId,
  scrollToImage
}) => {
  const { data = {}, loading, error } = useGetImages(imageId);

  const handleClick = () => {
    if (scrollToImage) scrollToImage(imageIndex);
    else if (enableLightbox) {
      toggleModal();
      handleSelectedImage(imageId);
    }
  };

  const { url: imageUrl = '', data: imageData = {} } = data.getFile || {
    getFile: { url: '', data: {} }
  };
  const { altText } = getImageData({}, imageData);

  const className =
    selectedImageId === imageId
      ? 'thumbnail-carousel-image thumbnail-carousel-image--selected'
      : 'thumbnail-carousel-image';

  return {
    loading,
    error,
    className,
    imageId,
    imageUrl,
    altText,
    priority,
    handleClick
  };
};

useThumbnailImage.propTypes = {
  imageId: PropTypes.string.isRequired,
  selectedImageId: PropTypes.string.isRequired,
  enableLightbox: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSelectedImage: PropTypes.func.isRequired,
  priority: PropTypes.bool.isRequired,
  scrollToImage: PropTypes.func
};

useThumbnailImage.defaultProps = {
  scrollToImage: null
};

export default useThumbnailImage;
